import { RISK_COLORS } from '@client/theme-constants';

export function formatRiskNumber(id: bigint | number, prefix: string | null | undefined): string {
    return prefix ? `${prefix}-${id}` : String(id);
}

export const getRiskMatrixColorScheme = (likelihoodsLength: number, impactsLength: number) => {
    const colorSchemes = {
        '3x3': [
            [RISK_COLORS.medium, RISK_COLORS.mediumHigh, RISK_COLORS.high],
            [RISK_COLORS.mediumLow, RISK_COLORS.medium, RISK_COLORS.mediumHigh],
            [RISK_COLORS.low, RISK_COLORS.mediumLow, RISK_COLORS.medium],
        ],
        '4x4': [
            [RISK_COLORS.medium, RISK_COLORS.mediumHigh, RISK_COLORS.mediumHigh, RISK_COLORS.high],
            [RISK_COLORS.mediumLow, RISK_COLORS.medium, RISK_COLORS.mediumHigh, RISK_COLORS.mediumHigh],
            [RISK_COLORS.mediumLow, RISK_COLORS.mediumLow, RISK_COLORS.medium, RISK_COLORS.mediumHigh],
            [RISK_COLORS.low, RISK_COLORS.mediumLow, RISK_COLORS.mediumLow, RISK_COLORS.medium],
        ],
        '5x5': [
            [RISK_COLORS.medium, RISK_COLORS.medium, RISK_COLORS.mediumHigh, RISK_COLORS.mediumHigh, RISK_COLORS.high],
            [
                RISK_COLORS.medium,
                RISK_COLORS.medium,
                RISK_COLORS.medium,
                RISK_COLORS.mediumHigh,
                RISK_COLORS.mediumHigh,
            ],
            [RISK_COLORS.mediumLow, RISK_COLORS.medium, RISK_COLORS.medium, RISK_COLORS.medium, RISK_COLORS.mediumHigh],
            [RISK_COLORS.mediumLow, RISK_COLORS.mediumLow, RISK_COLORS.medium, RISK_COLORS.medium, RISK_COLORS.medium],
            [RISK_COLORS.low, RISK_COLORS.mediumLow, RISK_COLORS.mediumLow, RISK_COLORS.medium, RISK_COLORS.medium],
        ],
    };
    const key = `${likelihoodsLength}x${impactsLength}`;
    return colorSchemes[key as keyof typeof colorSchemes] || [];
};
